import accountRoutes from '~/router/routes/car/account/index.ts'
import playgroundRoutes from '~/router/routes/car/playground/index.ts'
import newFormRoutes from '~/router/routes/car/classifieds/new.ts'
import editRoutes from '~/router/routes/car/classifieds/edit.ts'
import classifiedsRoutes from '~/router/routes/car/classifieds/index.ts'
import usersRoutes from '~/router/routes/car/users.ts'
import classifiedViewRoutes from '~/router/routes/car/classifieds/view.ts'
import classifiedSearchRoutes from '~/router/routes/car/classifieds/search/index.ts'
import searchClassifiedByIdRoutes from '~/router/routes/car/search-classified-by-id.ts'
import parkingRoutes from '~/router/routes/car/parking.ts'
import pathDealerSiteRoutes from '~/router/routes/car/dealers/site/path.ts'
import dealerIntegrationRoutes from '~/router/routes/car/dealers/integration.ts'
import dealersRegionRoutes from '~/router/routes/car/dealers/index.ts'
import informationRoutes from '~/router/routes/car/information.ts'
import adminRoutes from '~/router/routes/car/admin/index.ts'
import blacklistRoutes from '~/router/routes/car/blacklist.ts'
import indexRoutes from '~/router/routes/car/index.ts'
import advertisingRoutes from '~/router/routes/car/advertising.ts'
import qnaRoutes from '~/router/routes/car/qna.ts'
import externalCertificatesRoutes from '~/router/routes/car/external-certificates.ts'
import notificationsRoutes from '~/router/routes/car/notifications.ts'
import analyticsRoutes from '~/router/routes/car/analytics.ts'
import latestRoutes from '~/router/routes/car/latest.ts'
import detailedSearchRoutes from '~/router/routes/car/classifieds/search/detailed-search.ts'
import tradesRoutes from '~/router/routes/car/trades.ts'
import auditsLogin from '~/router/routes/car/audits-login.ts'
import oneClickTouchRoutes from '~/router/routes/car/classifieds/one-click-touch.ts'
import landingRoutes from '~/router/routes/car/landing.ts'
import authRoutes from '~/router/routes/car/auth.ts'
import unsubscribeRoutes from '~/router/routes/car/unsubscribe.ts'
import auditRoutes from '~/router/routes/car/audits.ts'
import deleteRatingForm from '~/router/routes/car/classifieds/delete-rating-form.ts'
import classifiedPrintRoutes from '~/router/routes/car/classifieds/print.ts'
import shortsRoutes from '~/router/routes/car/shorts.ts'
import vehicleServiceRoutes from '~/router/routes/car/vehicle-service.ts'
import loansRoutes from '~/router/routes/car/loans.ts'
import xmlRoutes from '~/router/routes/car/xml.ts'
import facebookRoutes from '~/router/routes/car/facebook.ts'
import saleRequestsRoutes from '~/router/routes/car/sale-requests.ts'
import alphaBankRoutes from '~/router/routes/car/alpha-bank'
import marketplaceRoutes from '~/router/routes/car/marketplace.ts'
import aboutUsRoutes from '~/router/routes/car/about-us.ts'
import shortUrlRoutes from '~/router/routes/car/short-url.ts'
import contestTermsRoutes from '~/router/routes/car/contest-terms'
import managersRoutes from '~/router/routes/car/managers.ts'

// When adding new routes remember: if they start with /user/ add them on top to avoid override by userProfileRoutes

export default [
  ...accountRoutes,
  ...playgroundRoutes,
  ...newFormRoutes,
  ...editRoutes,
  ...usersRoutes,
  ...dealersRegionRoutes,
  ...classifiedViewRoutes,
  ...classifiedSearchRoutes,
  ...classifiedsRoutes,
  ...searchClassifiedByIdRoutes,
  ...parkingRoutes,
  ...pathDealerSiteRoutes,
  ...dealerIntegrationRoutes,
  ...informationRoutes,
  ...adminRoutes,
  ...blacklistRoutes,
  ...indexRoutes,
  ...advertisingRoutes,
  ...qnaRoutes,
  ...externalCertificatesRoutes,
  ...notificationsRoutes,
  ...analyticsRoutes,
  ...latestRoutes,
  ...detailedSearchRoutes,
  ...tradesRoutes,
  ...auditsLogin,
  ...oneClickTouchRoutes,
  ...landingRoutes,
  ...authRoutes,
  ...unsubscribeRoutes,
  ...auditRoutes,
  ...deleteRatingForm,
  ...classifiedPrintRoutes,
  ...shortsRoutes,
  ...vehicleServiceRoutes,
  ...loansRoutes,
  ...alphaBankRoutes,
  ...xmlRoutes,
  ...facebookRoutes,
  ...saleRequestsRoutes,
  ...marketplaceRoutes,
  ...aboutUsRoutes,
  ...shortUrlRoutes,
  ...contestTermsRoutes,
  ...managersRoutes
]
